mutation DisqualifyGiveawayWinner($giveawayId: ID!, $twitchUserId: ID!, $reason: String!) {
  giveaway: StreamToolsDisqualifyGiveawayWinner(giveawayId: $giveawayId, twitchUserId: $twitchUserId, reason: $reason) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
    draw {
      drawId
      methodVersion
      eligibleCount
      targetRound
      fallbackUsed
      drawnAt
      shortPool
      requestedWinnerCount
      requestedAlternateCount
      winners {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      alternates {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      disqualifications {
        twitchUserId
        reason
        byUserId
        at
        promotedTwitchUserId
      }
    }
  }
}
